import * as actions from '../../Action/Tenant/AddDocuments'

export const initialState = {   
    documentName:"",   
    loaderStatus:false,
    addDocumentFailure:null
}

export default function reducer(state = initialState, action){

    switch(action.type){
        case actions.DOCUMENTNAME : return documentName(state,action);        
        case actions.RESETDATA : return ResetData(state,action);
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action);
        case actions.DOCUMENTFAILURE: return addDocumentFailure(state,action)
    default: return state    
    }
}


const documentName = (state,action) => {
    return {
        ...state,
        documentName: action.payload
    }
}


const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}

const addDocumentFailure =(state,action) => {
    return{
        ...state,
        addDocumentFailure: action.payload
    }
}

const ResetData = (state,action) => {
    
    return {
            ...state       
    }
}


